$(document).ready(function (params) {
  var swiperItems = document.querySelectorAll(".reveal .myswiper");
  swiperItems.forEach((swiperElement) => {
    var item = swiperElement.querySelector(".swiper");
    var swiper = new Swiper(item, {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
});
$(document).ready(function (params) {
  console.log("abc");
  $(".register_btn-custom").click(function (params) {
    $(this).addClass("active").siblings().removeClass("active");
    $(".signin_item").addClass("hidden");
    $(".customerregister_item").removeClass("hidden");
  });
  $(".login_btn_custom").click(function (params) {
    $(this).addClass("active").siblings().removeClass("active");
    $(".signin_item").removeClass("hidden");
    $(".customerregister_item").addClass("hidden");
  });
  // Function to check if a slide is in the viewport and update active class
  function checkSlides() {
    $(".product-medias__main .swiper-slide").each(function () {
      var slide = $(this);
      if (isInViewport(slide)) {
        var mediaId = slide.attr("data-media-id");
        $(".dots__container .v-min").each(function () {
          var dot = $(this);
          if (dot.attr("dot-id") == mediaId) {
            dot.addClass("active");
          } else {
            dot.removeClass("active");
          }
        });
      }
    });
  }

  // Function to check if an element is in the viewport
  function isInViewport(element) {
    var elementTop = element.offset().top;
    var elementBottom = elementTop + element.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  checkSlides();
  $(window).on("scroll", checkSlides);
  if (window.innerWidth > 767) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if ($(node).hasClass("swiper-slide")) {
            checkSlides();
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  // .................
  function scrollToSlide(mediaId) {
    var targetSlide = $(
      '.product-medias__main .swiper-slide[data-media-id="' + mediaId + '"]'
    );
    if (targetSlide.length) {
      $("html, body").animate(
        {
          scrollTop: targetSlide.offset().top,
        },
        500
      ); // 2s ease-in-out animation
    }
  }

  // Click event listener for buttons
  $(".dots__container .v-min").on("click", function () {
    var dotId = $(this).attr("dot-id");
    console.log(dotId);
    scrollToSlide(dotId);
  });

  // Custom easing function for the animation
  $.extend($.easing, {
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
      return (c / 2) * ((t -= 2) * t * t + 2) + b;
    },
  });

  document
    .querySelector(".site-nav--mobile .search-buttond")
    .addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent the click event from propagating to the document
      const secondaryNav = document.querySelector(".secondary-nav");
      const siteHeader = document.querySelector(".site-header");

      // Toggle the active class for both elements
      secondaryNav.classList.toggle("active");
      siteHeader.classList.toggle("bg-white");

      // Focus on the search bar inside secondaryNav
      secondaryNav.querySelector(".search-bar").focus();
    });
});

$(document).ready(function () {
  $(".collapsible-tab collapsible-button").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next(".collapsible-content").slideToggle();
  });

  const productDetailInfo = document.querySelector(
    ".product__info .product-details-wrapper"
  );
  const productInfo = document.querySelector(".product__info");

  function addActiveClass() {
    if (event.target === productDetailInfo) {
      infoHiehgt();
      productInfo.classList.toggle("active_info");
    }
  }
  if (productDetailInfo) {
    infoHiehgt();
    productDetailInfo.addEventListener("click", addActiveClass);
    productDetailInfo.addEventListener("dragstart", addActiveClass);
    $(window).on("scroll", function () {
      infoHiehgt();
    });
  }
  function infoHiehgt() {
    let height = productInfo.clientHeight;
    height = height + "px";
    // productInfo.style.transform = 'translateY(calc('+height+' - 68px))';
    productInfo.style.bottom = "calc(-" + height + " + 150px)";
    productInfo.style.opacity = "1";
  }

  const notSwiper = document.querySelector(".not__swiper");

  function checkPosition() {
    const rect = notSwiper.getBoundingClientRect();

    if (rect.bottom <= window.innerHeight) {
      productInfo.classList.add("active_info");
    } else {
      productInfo.classList.remove("active_info");
    }
  }

  if (productInfo) {
    window.addEventListener("scroll", checkPosition);
  }
  if (notSwiper) {
    checkPosition();
  }
});

$(".faq__item .faq_question").click(function () {
  $(this).closest(".faq__item").toggleClass("open");
  $(this).closest(".faq__item").find(".faq__answer").slideToggle();
});
$(".faq_catg select").on("change", function (e) {
  var optionSelected = $("option:selected", this);
  var valueSelected = this.value;
  $(".faq__item").removeClass("active_item");
  $('.faq__item[data-handle="' + valueSelected + '"]').addClass("active_item");
  // console.log(valueSelected);
});
$(document).ready(function () {
  $(".selected-display").on("click", function () {
    const $currentCustomSelect = $(this).closest(".custom-select");
    const $optionsContainer = $currentCustomSelect.find(".options-container");
    const $arrow = $currentCustomSelect.find(".arrow");

    // Remove 'active' and 'rotate' classes from all other instances
    $(".custom-select .options-container")
      .not($optionsContainer)
      .removeClass("active");
    $(".custom-select .arrow").not($arrow).removeClass("rotate");

    // Toggle 'active' and 'rotate' classes for the current custom-select
    $optionsContainer.toggleClass("active");
    $arrow.toggleClass("rotate");
  });

  $(".options-container li").on("click", function () {
    if ($(this).find("a").attr("href")) {
      window.location.href = $(this).find("a").attr("href");
    }
    const selectedText = $(this).text();
    $(this)
      .closest(".custom-select-wrapper")
      .find(".selected-display")
      .text(selectedText)
      .removeClass("selected_grey");
    $(this).addClass("selected").siblings().removeClass("selected");
    var valueSelected = $(this).attr("value");
    $(".faq__item").removeClass("active_item");
    $('.faq__item[data-handle="' + valueSelected + '"]').addClass(
      "active_item"
    );
    $(".options-container").removeClass("active");
    $(".custom-select .arrow").removeClass("rotate");
  });

  // Close the dropdown if clicking outside of it
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".custom-select").length) {
      $(".options-container").removeClass("active");
      $(".custom-select .arrow").removeClass("rotate");
    }
  });

  $(".popup_media .swiper-slide").click(function (params) {
    $(".popup_media .close").trigger("click");
  });

  // const openPopupBtns = document.querySelectorAll('[data-main-media-link]');
  // const closePopupBtn = document.getElementById('closePopupBtn');
  // const popup = document.getElementById('popup_media');
  // const body = document.querySelector('body');
  // let swiper;
  //                 // loop: true,
  //                 // navigation: {
  //                 //     nextEl: '.swiper-button-next',
  //                 //     prevEl: '.swiper-button-prev',
  //                 // },
  // // Add event listener to each button
  // openPopupBtns.forEach(function(btn) {
  //     btn.addEventListener('click', function(e) {
  //         e.preventDefault();
  //        var slideId = $(this).closest('.swiper-slide').attr('data-media-id');

  //         console.log(slideId);
  //         popup.classList.remove('hide');
  //         body.classList.add('overflow_hidden');
  //         // $('.popup_media .swiper-wrapper').animate({
  //         //   scrollTop: $('.popup-content .swiper-slide[data-media-id="26125987119241"]').offset().top
  //         // }, 100);
  //         $('.popup_media .swiper-wrapper').animate({
  //             scrollTop: $('.popup-content .swiper-slide[data-media-id="'+slideId+'"]').offset().top - $('.popup_media .swiper-wrapper').offset().top + $('.popup_media .swiper-wrapper').scrollTop()
  //         }, 0);

  //         // Check if Swiper is already initialized, and if not, initialize it
  //         // if (!swiper) {
  //         //     swiper = new Swiper('.swiper-container', {
  //         //         direction: "vertical",
  //         //         slidesPerView: "auto",
  //         //         freeMode: true,
  //         //         mousewheel: true,
  //         //         pagination: {
  //         //             el: '.swiper-pagination',
  //         //             clickable: true,
  //         //         },
  //         //     });
  //         // }
  //     });
  // });

  const openPopupBtns = document.querySelectorAll("[data-main-media-link]");
  const closePopupBtn = document.getElementById("closePopupBtn");
  const popup = document.getElementById("popup_media");
  const body = document.querySelector("body");

  // openPopupBtns.forEach(function(btn) {
  //     btn.addEventListener('click', function(e) {
  //         e.preventDefault();
  //         var slideId = $(this).closest('.swiper-slide').attr('data-media-id');

  //         console.log(slideId);

  //         // Remove the 'hide' class and add the animation
  //         popup.classList.remove('hide');

  //         // Disable body scroll when popup is open
  //         body.classList.add('overflow_hidden');

  //         // Scroll to the correct media slide
  //         $('.popup_media .swiper-wrapper').animate({
  //             scrollTop: $('.popup-content .swiper-slide[data-media-id="'+slideId+'"]').offset().top - $('.popup_media .swiper-wrapper').offset().top + $('.popup_media .swiper-wrapper').scrollTop()
  //         }, 0);
  //         popup.style.animation = "openpopindesktop .7s cubic-bezier(.22,1,.36,1) forwards";
  //     });
  // });

  // // Close popup
  // closePopupBtn.addEventListener('click', function() {
  //     popup.style.animation = "closepopindesktop .7s cubic-bezier(.22,1,.36,1) forwards";
  //     setTimeout(function() {
  //         popup.classList.add('hide');
  //         body.classList.remove('overflow_hidden');
  //     }, 100);
  // });

  // closePopupBtn?.addEventListener('click', function() {
  //     popup.classList.add('hide');
  //     body.classList.remove('overflow_hidden');
  // });

  $("a").removeAttr("title");

  $(".close_news_popup").click(function (e) {
    e.preventDefault();
    $(".email-signup__main").removeClass("open").addClass("close"); // Add close class for fadeout
    setTimeout(function () {
      $(".email-signup__main").css("display", "none"); // Hide after animation
    }, 500); // Duration of the fadeout animation
  });

  $(".email-signup__button").click(function (e) {
    e.preventDefault();
    $(".email-signup__main")
      .css("display", "flex")
      .removeClass("close")
      .addClass("open"); // Add open class for fadein
  });

  $(".hamburger-nav-button").click(function (params) {
    $(this).toggleClass("menu-active");
    $(".mobile-nav.mobile-nav--main").toggleClass("mobile-nav__active");
  });

  $("textarea[name='contact[body]']").on("input", function () {
    // Get the current length of the textarea value
    var charCount = $(this).val().length;

    // Update the span with the current character count
    $(this).siblings("label").find("span").text(charCount);
  });
});
// ....................cart page script..........
$(document).ready(function () {
  $(document).on("click", ".js-qty__adjustt", function (params) {
    params.preventDefault();
    // $(".js-qty__adjust").on("click", function () {
    var $input = $(this).closest(".js-qty").find(".js-qty__num");
    var quantity = parseInt($input.val(), 10);
    var isIncrease = $(this).hasClass("js-qty__adjust--plus");
    var isDecrease = $(this).hasClass("js-qty__adjust--minus");
    if (isIncrease) {
      quantity += 1;
    } else if (isDecrease && quantity == 1) {
      quantity -= 1;
    } else if (isDecrease && quantity > 1) {
      quantity -= 1;
    }
    console.log(quantity);
    $input.val(quantity); // Update input value
    var variantId = $input.attr("id").replace("updates_", ""); // Extract variant ID
    updateCart(variantId, quantity); // Call function to update cart
  });

  function updateCart(variantId, quantity) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: JSON.stringify({
        updates: {
          [variantId]: quantity,
        },
      }),
      dataType: "json",
      contentType: "application/json",
      success: function (data) {
        console.log("Cart updated:", data);
        extract();
        // Optionally, refresh cart UI or show a success message
      },
      error: function (error) {
        console.error("Error updating cart:", error);
      },
    });
  }
});
function extract() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartBubble = document.querySelector("[data-cart-count-indicator]");
      if (cartBubble) {
        cartBubble.textContent = cart.item_count;
      }
    });

  var sec_id = $("[data-section-id]").attr("data-section-id");
  fetch(`/sections?section_id=${sec_id}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newSection = doc.querySelector(`[data-section-id="${sec_id}"]`);

      if (newSection) {
        const targetSection = document.querySelector(
          `[data-section-id="${sec_id}"]`
        );

        if (targetSection) {
          targetSection.innerHTML = newSection.innerHTML;
        } else {
          console.error("No .shopify-section found for section ID:", sec_id);
        }
      } else {
        console.error("No new section found with ID:", sec_id);
      }
    })
    .catch((error) => {
      console.error("Error fetching section:", error);
    });
}

// custom newsletter drawer open and close
document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector('.nlt-drawer-opener');
  const closeButton = document.querySelector('.nlt_drawer-close');
  const newsletterDrawer = document.querySelector('.custom--newsletter');
  const body = document.body;
  const nltOverlay = document.querySelector('#DrawerOverlay');

  
  if (toggleButton && newsletterDrawer) {
    toggleButton.addEventListener('click', function (e) {
      e.preventDefault();
      newsletterDrawer.classList.toggle('active');
      body.classList.add('js-drawer-open-right', 'custom-nlt-overlay');
    });
  }
  if (closeButton && newsletterDrawer) {
    closeButton.addEventListener('click', function () {
      newsletterDrawer.classList.remove('active');
       body.classList.remove('js-drawer-open-right', 'custom-nlt-overlay');
    });
  }
   if (nltOverlay) {
    nltOverlay.addEventListener('click', function () {
      newsletterDrawer.classList.remove('active');
       body.classList.remove('js-drawer-open-right', 'custom-nlt-overlay');
    });
  }
  
});

 // left contact drawer open and close

document.addEventListener("DOMContentLoaded", function () {
  
  const body = document.body;
  const contactOverlay = document.querySelector('#DrawerOverlay');
  const rightDrawerLink = document.querySelector('.contact--drawer__link');
  const rightContactDrawer = document.querySelector('.contact-form-drawer');
  const rightContactDrawerClose = document.querySelector('.right-contact_drawer-close');
  const rightDoneLink = document.querySelector('.right-done-link');
  const rightContactOverlay = document.querySelector('.right-contact-overlay #DrawerOverlay');

  
  
   
   if (contactOverlay) {
     contactOverlay.addEventListener('click', function () {
       rightContactDrawer.classList.remove('active');
        body.classList.remove('js-drawer-open-right', 'right-contact-overlay');
     });
   }
  
  if (rightDrawerLink && rightContactDrawer) {
     rightDrawerLink.addEventListener('click', function (e) {
        e.preventDefault();
        body.classList.add('js-drawer-open-right', 'right-contact-overlay');
        rightContactDrawer.classList.add('active');
     });
   }
  if (rightContactDrawerClose && rightContactDrawer) {
    rightContactDrawerClose.addEventListener('click', function () {
       rightContactDrawer.classList.remove('active');
       body.classList.remove('js-drawer-open-right', 'right-contact-overlay');
     });
  }
  if (rightDoneLink && rightContactDrawer) {
     rightDoneLink.addEventListener('click', function (e) {
        e.preventDefault();
        rightContactDrawer.classList.remove('active');
        body.classList.remove('js-drawer-open-right', 'right-contact-overlay');
     });
   }
});

// faqs categories linked

  document.querySelectorAll('.contact--container__footer-link').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const category = this.getAttribute('data-category');
      window.location.href = `/pages/faq?category=${encodeURIComponent(category)}`;
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const category = params.get('category');
  if (!category) return;

  const listItems = document.querySelectorAll('.custom-select .options-container li');
  
  const selectedDisplay = document.querySelector('.selected-display p');
  console.log('Category:',category);
  console.log('Selected Category:',selectedDisplay.innerText );

 if (category && selectedDisplay) {
    // Remove hyphens and capitalize the first letter of each word
    const formattedCategory = category
      .replace(/-/g, ' ') // Replace hyphens with spaces
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word

    selectedDisplay.textContent = formattedCategory;
  }
 
  listItems.forEach(li => {
    if (li.getAttribute('value') === category) {
      li.classList.add('selected');
      
    } else {
      li.classList.remove('selected');
    }
  });

  const faqItems = document.querySelectorAll('.faq__items .faq__item');

faqItems.forEach(item => {
  // pehle sab se .active_item class hata do (optional agar single active item chahiye ho)
  item.classList.remove('active_item');

  // agar data-handle match karta ho to add karo
  if (item.getAttribute('data-handle') === category.trim()) {
    item.classList.add('active_item');
  }
});
  
});

// search drawer and input js

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.secondary-nav.hs_drawer');
  const searchBar = drawer?.querySelector('.search-bar');
  const closeButton = document.querySelector('.ds_drawer-close');
  const drawerOverlay = document.querySelector('#NavDrawerOverlay');
  const clearBtn = drawer?.querySelector('.custom-form .clear-btn');

  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('q');

  const fillSearchBar = () => {
    if (query && searchBar && clearBtn) {
      searchBar.value = query;
      clearBtn.style.setProperty('display', 'block', 'important');
    }
  };

  // 🟡 Fill search bar on page load if drawer is already open
  if (drawer.classList.contains('active')) {
    fillSearchBar();
  }

  // 🟡 MutationObserver for dynamic drawer open
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        if (drawer.classList.contains('active')) {
          searchBar?.focus();
          fillSearchBar(); // 🟢 Now also fills when drawer opens dynamically
        } else {
          searchBar?.blur();
        }
      }
    });
  });

  if (searchBar && clearBtn) {
    searchBar.addEventListener('input', () => {
      if (searchBar.value.trim() !== '') {
        clearBtn.style.setProperty('display', 'block', 'important');
      } else {
        clearBtn.style.setProperty('display', 'none', 'important');
      }
    });

    clearBtn.addEventListener('click', () => {
      searchBar.value = '';
      clearBtn.style.setProperty('display', 'none', 'important');
      searchBar.focus();
    });
  }

  if (closeButton && drawer) {
    closeButton.addEventListener('click', function () {
      drawer.classList.remove('active');
      drawerOverlay?.classList.remove('active');
      searchBar?.blur();
      document.body.style.overflow = '';
    });
  }

  observer.observe(drawer, {
    attributes: true
  });
});


